import { render, staticRenderFns } from "./ContractBankAccountsSection.vue?vue&type=template&id=5af2c946&"
import script from "./ContractBankAccountsSection.vue?vue&type=script&lang=js&"
export * from "./ContractBankAccountsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports